"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
var _Icon2 = require("../../../Icon");
var _Icon3 = _interopRequireDefault(_Icon2);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
var IconMapsPin1 = /*#__PURE__*/
function (_Icon) {
  _inherits(IconMapsPin1, _Icon);
  function IconMapsPin1(props) {
    var _this;
    _classCallCheck(this, IconMapsPin1);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(IconMapsPin1).call(this, props));
    _this.name = 'IconMapsPin1';
    _this.icon = _react2.default.createElement("svg", {
      viewBox: "0 0 24 24",
      width: "1em",
      height: "1em",
      focusable: "false",
      "aria-hidden": "true",
      role: "presentation"
    }, _react2.default.createElement("g", {
      className: "maps-pin-1_svg__group0"
    }, _react2.default.createElement("path", {
      className: "maps-pin-1_svg__path0",
      d: "M7.5 21.977a.997.997 0 01-.582-.187l-6.5-4.643A1.004 1.004 0 010 16.333V1.562A.99.99 0 01.294.855.99.99 0 011 .563c.211 0 .412.065.582.187L7.5 4.977 13.918.394a.987.987 0 01.62-.185c.191.006.382.07.543.185l6.5 4.642c.263.188.419.492.419.815v4.742a.5.5 0 01-1 0V5.85l-6-4.286v9.027a.5.5 0 01-1 0V1.564L8 5.849V20.62l5.209-3.721a.502.502 0 01.783.489.497.497 0 01-.203.325L8.082 21.79a.997.997 0 01-.582.187zM1 16.333l6 4.286V5.849L1 1.563v14.77z"
    }), _react2.default.createElement("path", {
      className: "maps-pin-1_svg__path1",
      d: "M19.499 23.795a.988.988 0 01-.781-.377C17.329 21.662 15 18.442 15 16.591c0-2.481 2.019-4.5 4.5-4.5s4.5 2.019 4.5 4.5c0 1.851-2.328 5.07-3.716 6.824a.996.996 0 01-.785.38zm.001-10.704c-1.93 0-3.5 1.57-3.5 3.5 0 1.311 1.808 4.065 3.5 6.204 1.692-2.139 3.5-4.892 3.5-6.204 0-1.93-1.57-3.5-3.5-3.5z"
    }), _react2.default.createElement("path", {
      className: "maps-pin-1_svg__path2",
      d: "M19.5 18.591c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2zm0-3a1 1 0 100 2 1 1 0 000-2z"
    })));
    return _this;
  }
  return IconMapsPin1;
}(_Icon3.default);
exports.default = IconMapsPin1;